export default __webpack_public_path__ + "static/media/LV.5dc39a23.svg";